<script>
	import anime from 'animejs'
	import { onMount } from 'svelte'
	import IntersectionObserver from 'svelte-intersection-observer'
	import Saos from '$lib/components/Saos.svelte'
	import Thumbnails from '$lib/components/thumbnails/Thumbnails.svelte'
	import { STEP } from '$lib/consts'
	import DynamicPageWrapper from '$lib/modules/cms/DynamicPageWrapper/DynamicPageWrapper.svelte'
	import ContentSlider from '$lib/modules/layout/ContentSlider.svelte'
	import FAQ_wrap from '$lib/modules/products/FAQ_wrap.svelte'
	import { HEAT_PUMP, WOLTADVISOR, FINANCING, GRANTS } from '$lib/routes'
	import { t } from '$lib/translations'
	//import { WindowIsolation } from '$lib/server/core-api/types.js'
	import { PUBLIC_WOLTAIR_WEB_CODE } from '$env/static/public'

	export let data
	//const homeanimation = 'default-in 1s cubic-bezier(0.35, 0.5, 0.65, 0.95) both'

	let scrollInWrapper
	let stickyContainer
	let stickyContent

	let bgImage

	let text1
	let text2
	let text3
	let text4
	let text5

	let tl
	let element
	let intersecting = true

	onMount(() => {
		if (stickyContainer?.offsetHeight) {
			let narrowStickyContent = null

			const transformScrollBox = () => {
				if (stickyContainer.offsetHeight > window.innerHeight) {
					narrowStickyContent = stickyContent
					stickyContainer.style.maxHeight = '100vh'
					stickyContainer.style.overflow = 'hidden'
				} else {
					narrowStickyContent = null
					stickyContainer.style.maxHeight = 'none'
					stickyContainer.style.overflow = 'hidden'
				}
			}

			const getTranslateValue = (item) => {
				if (
					stickyContainer &&
					item.getBoundingClientRect().top - stickyContainer.getBoundingClientRect().top >
						window.innerHeight / 2
				) {
					return (
						stickyContainer.getBoundingClientRect().top -
						item.getBoundingClientRect().top +
						window.innerHeight / 2
					)
				} else {
					return 0
				}
			}

			tl = anime.timeline({
				autoplay: false,
				loop: true,
				easing: 'linear',
				direction: 'alternate',
				change: transformScrollBox()
			})

			tl.add({ targets: text1, opacity: ['1', '0.4'], scale: ['1.1', '1'], duration: 100 })
				.add({ targets: text2, opacity: ['0.4', '1'], scale: ['1', '1.1'], duration: 100 }, '-=100')
				.add(
					{
						targets: narrowStickyContent,
						translateY: getTranslateValue(text2),
						duration: 100
					},
					'-=100'
				)
				.add({ targets: text2, opacity: ['1', '0.4'], scale: ['1.1', '1'], duration: 100 })
				.add({ targets: text3, opacity: ['0.4', '1'], scale: ['1', '1.1'], duration: 100 }, '-=100')
				.add(
					{
						targets: narrowStickyContent,
						translateY: getTranslateValue(text3),
						duration: 100
					},
					'-=100'
				)
				.add({ targets: text3, opacity: ['1', '0.4'], scale: ['1.1', '1'], duration: 100 })
				.add({ targets: text4, opacity: ['0.4', '1'], scale: ['1', '1.1'], duration: 100 }, '-=100')
				.add(
					{
						targets: narrowStickyContent,
						translateY: getTranslateValue(text4),
						duration: 100
					},
					'-=100'
				)
				.add({ targets: text4, opacity: ['1', '0.4'], scale: ['1.1', '1'], duration: 100 })
				.add({ targets: text5, opacity: ['0.4', '1'], scale: ['1', '1.1'], duration: 100 }, '-=100')
				.add(
					{
						targets: narrowStickyContent,
						translateY: getTranslateValue(text5),
						duration: 100
					},
					'-=100'
				)
				.add({ targets: bgImage, scale: ['1', '1.25'], duration: 400 }, '-=400')

			window.onscroll = () => {
				tl.seek((scrollPercent() / 100) * tl.duration)
			}

			const scrollPercent = () => {
				const stickyTop = stickyContainer.getBoundingClientRect().top
				const scrollInTop = scrollInWrapper.getBoundingClientRect().top
				const scrollInHeight = scrollInWrapper.offsetHeight
				const stickyHeight = stickyContainer.offsetHeight
				return ((stickyTop - scrollInTop) / (scrollInHeight - stickyHeight)) * 100
			}
		}
	})
</script>

{#if data.type === 'productPage' && data.components}
	<DynamicPageWrapper
		header={data.header}
		title={data.title}
		components={data.components}
		type={data.type}
	/>
{:else}
	{#if data.featureConfig.woltadvisor.hvac}
		<a
			href="/{HEAT_PUMP}/{WOLTADVISOR}?{STEP}=0"
			class="sticky-button page-fullwidth text-1.5xl-res font-semibold text-neutral-100
			{intersecting ? 'translate-y-[100%]' : 'translate-y-[0]'}"
			class:intersecting>{t('web.thirty_fifty.hvac.header.button')}</a
		>
	{/if}

	<section class="header-section page-fullwidth bg-neutral-900">
		<div
			class="page-wrapper relative mt-0 box-content flex flex-col items-center px-0 md:flex-row md:items-start"
		>
			<div
				class="z-10 mb-24-res mt-12-res flex flex-col items-center px-4 text-center md:basis-1/2 md:items-start xl:w-full xl:max-w-xl"
			>
				<h1 class="my-0 mb-0 mt-0 inline text-white md:text-left xl:max-w-2xl">
					{t('web.thirty_fifty.hvac.header.heading')}
				</h1>
				<p class="my-10 text-base-res text-white md:text-left">
					{t('web.thirty_fifty.hvac.header.subtext')}
				</p>

				{#if data.featureConfig.woltadvisor.hvac}
					<IntersectionObserver {element} bind:intersecting>
						<a
							bind:this={element}
							class="button-special text-1.5xl-res whitespace-nowrap font-semibold text-white"
							href="/{HEAT_PUMP}/{WOLTADVISOR}"
						>
							{t('web.thirty_fifty.hvac.header.button')}
						</a>
					</IntersectionObserver>
				{/if}
			</div>

			<img
				src="/images/persons/HVAC-30-50-jan-kadlec-mobile.webp"
				class="header-image max-w-screen w-screen md:hidden"
				alt={t('web.thirty_fifty.hvac.header.imgAlt')}
			/>
		</div>
	</section>
	<!--
<div
	class="main-wrapper absolute left-[calc(50%-1px)] -z-10 h-full w-[calc(100vw+2px)] -translate-x-1/2 bg-neutral-100"
/>-->

	<section
		class="page-wrapper relative mt-12-res flex flex-col items-center justify-center gap-4 md:items-start lg:mt-20 lg:flex-row xl:justify-between"
	>
		<div class="mb-12 w-full text-left md:w-fit md:basis-[fit-content]">
			<h2 class="!mt-4-res mb-6-res tracking-normal md:w-fit">
				{t('web.thirty_fifty.hvac.terms.heading')}
			</h2>

			<!-- {#if detailedTerms}
			<a
				href={detailedTerms}
				target="_blank"
				class="full-terms w-full py-4 text-xs-res text-primary-500 md:text-left xl:w-5/6"
				>{t('web.thirty_fifty.hvac.terms.fullTerms')}</a
			>{/if} -->
		</div>

		<div
			class="grid w-full grid-cols-1 md:basis-3/5 md:grid-cols-2 md:gap-[5vw] xl:ml-auto xl:basis-[65%] xl:gap-28-res xl:gap-y-20"
		>
			<div class="col-span-1">
				<img src="/images/icons/30-50/line-grey.svg" alt="ikona, pruh" />
				<p
					class="font text-1.5xl-res mb-16-res mt-10-res leading-relaxed text-neutral-700 md:mb-4 md:mt-6 md:text-base"
				>
					{t('web.thirty_fifty.hvac.terms.term1')}
				</p>
			</div>
			<div class="col-span-1">
				<img src="/images/icons/30-50/line-grey.svg" alt="ikona, pruh" />
				<p
					class="text-1.5xl-res mb-16-res mt-10-res leading-relaxed text-neutral-700 md:mb-4 md:mt-6 md:text-base"
				>
					{t('web.thirty_fifty.hvac.terms.term2')}
				</p>
			</div>
			<div class="col-span-1">
				<img src="/images/icons/30-50/line-grey.svg" alt="ikona, pruh" />
				<p
					class="text-1.5xl-res mb-16-res mt-10-res leading-relaxed text-neutral-700 md:mb-4 md:mt-6 md:text-base"
				>
					{t('web.thirty_fifty.hvac.terms.term3')}
				</p>
			</div>
			<div class="col-span-1">
				<img src="/images/icons/30-50/line-grey.svg" alt="ikona, pruh" />
				<p
					class="text-1.5xl-res mb-16-res mt-10-res leading-relaxed text-neutral-700 md:mb-4 md:mt-6 md:text-base"
				>
					{t('web.thirty_fifty.hvac.terms.term4')}
				</p>
			</div>
		</div>
	</section>

	<section class="page-fullwidth mt-32-res">
		<h2 class="brands-intro mx-auto !mt-0 mb-0 px-4 tracking-normal md:max-w-3xl md:text-center">
			{@html t('web.thirty_fifty.hvac.brands.heading')}
		</h2>

		<div class="relative mt-24-res h-12 w-full">
			<div
				class="bg-animate-carousel absolute h-full w-full {PUBLIC_WOLTAIR_WEB_CODE === 'WOLTAIR_PL'
					? 'bg-[url(/images/brands/brands_pack-pl-mobile.svg)] lg:bg-[url(/images/brands/brands_pack-pl.svg)]'
					: 'bg-[url(/images/brands/brands_pack-2-mobile.svg)] lg:bg-[url(/images/brands/brands_pack.svg)]'}"
			>
				{t('web.thirty_fifty.hvac.brands.names')}
			</div>
		</div>
	</section>

	<section class="w-full">
		<div bind:this={scrollInWrapper} class="relative mt-32-res h-[500vh]">
			<div bind:this={stickyContainer} class="sticky top-0 h-fit min-h-[100vh] bg-neutral-900">
				<div
					class="relative top-0 flex h-fit min-h-[100vh] w-full items-center justify-center bg-cover bg-center"
				>
					<img
						bind:this={bgImage}
						src="/images/illustrations/30-50/woltair-30-50-warehouse.webp"
						class="absolute inset-0 m-auto h-full w-full object-cover"
						alt={t('web.thirty_fifty.hvac.advantages.imageAlt')}
					/>

					<ul
						bind:this={stickyContent}
						class="relative z-10 my-8-res w-[85vw] max-w-3xl items-center justify-center text-center text-3xl-res text-neutral-100"
					>
						<li class="mb-16-res scale-110 !list-none xl:text-left" bind:this={text1}>
							{@html t('web.thirty_fifty.hvac.advantages.text1')}
						</li>
						<li class="mb-16-res !list-none opacity-40 xl:text-left" bind:this={text2}>
							{@html t('web.thirty_fifty.hvac.advantages.text2')}
						</li>
						<li class="mb-16-res !list-none opacity-40 xl:text-left" bind:this={text3}>
							{@html t('web.thirty_fifty.hvac.advantages.text3')}
						</li>
						<li class="mb-16-res !list-none opacity-40 xl:text-left" bind:this={text4}>
							{@html t('web.thirty_fifty.hvac.advantages.text4')}
						</li>
						<li class="mb-16-res !list-none opacity-40 xl:text-left" bind:this={text5}>
							{@html t('web.thirty_fifty.hvac.advantages.text5')}
						</li>
					</ul>
				</div>
			</div>
		</div>
	</section>

	{#if (data.featureConfig.grants.hvac || data.featureConfig.financing.hvac) && PUBLIC_WOLTAIR_WEB_CODE !== 'WOLTAIR_PL'}
		<section class="page-wrapper my-24-res flex flex-col gap-6 md:flex-row md:justify-between">
			{#if data.featureConfig.grants.hvac}
				<div
					class="flex min-h-[95vw] basis-full flex-col rounded-3xl bg-[#D40307] bg-no-repeat p-12-res text-white md:min-h-[47.5vw] xl:min-h-0 xl:bg-[url(/images/logos/woltair-w-outline.svg)] xl:bg-[length:55%_auto] xl:bg-[120%_110%] xl:py-8-res"
				>
					<h3 class="!mt-0 !font-extrabold xl:max-w-[90%]">
						{@html t('web.thirty_fifty.hvac.boxes.box1.heading')}
					</h3>
					<p class="text-base-res xl:max-w-[60%]">
						{@html t('web.thirty_fifty.hvac.boxes.box1.text')}
					</p>
					<a
						href="/{GRANTS}"
						target="_blank"
						class="my-8 inline-block w-fit rounded-full bg-white px-12 py-[.75em] pt-[.8125em] text-sm font-semibold text-black transition-colors hover:bg-neutral-200"
						>{t('web.thirty_fifty.hvac.boxes.box1.button')}</a
					>
					<p
						class="!mt-auto max-w-[90%] text-xs font-light leading-normal tracking-wide xl:!mt-12 xl:max-w-56"
					>
						{@html t('web.thirty_fifty.hvac.boxes.box1.subtext')}
					</p>
				</div>
			{/if}
			{#if data.featureConfig.financing.hvac}
				<div
					class="flex min-h-[95vw] basis-full flex-col rounded-3xl bg-[#2A71EF] bg-no-repeat p-12-res text-white md:min-h-[47.5vw] xl:min-h-0 xl:bg-[url(/images/logos/stavebni-sporitelna-logo.webp)] xl:bg-[length:35%_auto] xl:bg-[93%_80%] xl:py-8-res"
				>
					<h3 class="!mt-0 !font-extrabold xl:max-w-[90%]">
						{@html t('web.thirty_fifty.hvac.boxes.box2.heading')}
					</h3>
					<p class="text-base-res xl:max-w-[60%]">
						{@html t('web.thirty_fifty.hvac.boxes.box2.text')}
					</p>
					<a
						href="/{FINANCING}"
						target="_blank"
						class="my-8 inline-block w-fit rounded-full bg-white px-12 py-[.75em] pt-[.8125em] text-sm font-semibold text-black transition-colors hover:bg-neutral-200"
						>{t('web.thirty_fifty.hvac.boxes.box2.button')}</a
					>
					<img
						src="/images/logos/burinka-mobile.webp"
						alt={t('web.thirty_fifty.hvac.boxes.box2.imgAlt')}
						class="mt-auto block max-w-[50%] xl:hidden"
					/>
				</div>
			{/if}
		</section>
	{/if}

	{#if data.featureConfig.references.hvac}
		<section class="page-fullwidth relative my-16-res">
			<Saos>
				<Thumbnails
					references={data.references}
					title={{
						text: t('web.thirty_fifty.hvac.thumbnails.heading'),
						textAlign: 'left',
						textSize: '4xl',
						lineWidth: '2/3'
					}}
					showTitle
					overflowPage
					enableSlideButtons
					fullscreenWidth
				/>
			</Saos>
		</section>
	{/if}

	<!--
  <div class="comparison">
	<Comparison {groups} {texts} showLogo enableSlideButtons />
  </div>-->
	{#if data.featureConfig.referenceQuotes}
		<section class="page-wrapper grid grid-cols-1 gap-16 sm:mt-0 md:grid-cols-12 xl:gap-10">
			<div
				class="col-span-1 flex flex-col items-center text-center md:order-3 md:col-span-5 md:mb-0 xl:col-span-4"
			>
				<div class="null relative max-w-[85%] sm:mt-10 md:max-w-full xl:mt-14">
					<h2 class="mt-6 text-4.5xl-res font-extrabold md:text-left">
						{t('web.thirty_fifty.hvac.reviews.heading')}
					</h2>

					<p class="text-lg-res md:max-w-full md:text-left">
						{t('web.thirty_fifty.hvac.reviews.text')}
					</p>
				</div>
			</div>

			<div class="order-2 col-span-1 hidden xl:block" />
			<div class="py-6 md:order-1 md:col-span-7 xl:col-span-5">
				<ContentSlider
					slideDuration="0.6s"
					type="quotes"
					slides={[
						{
							cite: t('web.thirty_fifty.hvac.reviews.review1.name'),
							quote: t('web.thirty_fifty.hvac.reviews.review1.text')
						},
						{
							cite: t('web.thirty_fifty.hvac.reviews.review2.name'),
							quote: t('web.thirty_fifty.hvac.reviews.review2.text')
						},
						{
							cite: t('web.thirty_fifty.hvac.reviews.review3.name'),
							quote: t('web.thirty_fifty.hvac.reviews.review3.text')
						},
						{
							cite: t('web.thirty_fifty.hvac.reviews.review4.name'),
							quote: t('web.thirty_fifty.hvac.reviews.review4.text')
						},
						{
							cite: t('web.thirty_fifty.hvac.reviews.review5.name'),
							quote: t('web.thirty_fifty.hvac.reviews.review5.text')
						}
					]}
				/>
			</div>
		</section>
	{/if}
	<!-- FAQ -->
	{#if data.faqs?.length && data.featureConfig.faq}
		<section class="page-wrapper mt-20-res">
			<h2 class="">
				{t('web.heat_pump.faq.heading')}
			</h2>

			<div class="mt-12-res flex w-full flex-col flex-wrap gap-x-10 pb-16 lg:flex-row">
				{#each data.faqs as faq}
					<FAQ_wrap>
						<svelte:fragment slot="question">{faq.question}</svelte:fragment>
						<svelte:fragment slot="answer">{@html faq.answer}</svelte:fragment>
					</FAQ_wrap>
				{/each}
			</div>
		</section>
	{/if}
{/if}

<style lang="scss">
	.sticky-button {
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		bottom: 0;
		z-index: 20;
		box-sizing: border-box;
		padding: 0.75em 0;
		text-align: center;
		font-weight: 600;
		color: #f7f7f7;
		text-shadow: 1px 1px rgba(0, 0, 0, 0.25);
		background-color: #5ab953;
		transition-duration: 500ms;
		transition-timing-function: ease-in-out;

		@screen md {
			&::after {
				margin-left: 1em;
				display: block;
				aspect-ratio: 1;
				height: 0.625em;
				background-image: url('/images/icons/30-50/arrow-right-shaft.svg');
				background-repeat: no-repeat;
				background-position: center center;
				background-size: contain;
				content: '';
				filter: drop-shadow(0 1px 1px rgba(0, 0, 0, 0.25));
			}
		}
	}

	.header-section {
		background-image: linear-gradient(to right bottom, rgb(206, 50, 77), rgb(207, 46, 40));
		@screen md {
			background-image: url('/images/persons/HVAC-30-50-jan-kadlec-bg.webp');
			background-size: auto 180%;
			background-position: center 35%;
			background-repeat: no-repeat;
		}
	}

	// .full-terms {
	// 	position: relative;
	// 	display: flex;
	// 	align-items: center;
	// 	justify-content: space-between;
	// 	border-top: 2px solid #e5e7eb;

	// 	&::after {
	// 		position: absolute;
	// 		right: 0;
	// 		display: block;
	// 		content: '';
	// 		aspect-ratio: 1/1;
	// 		height: 1em;
	// 		background-image: url('/images/icons/30-50/arrow-right-short.svg');
	// 		background-repeat: no-repeat;
	// 		background-size: contain;
	// 		background-position: center;
	// 	}

	// 	&:hover {
	// 		text-decoration: underline;
	// 	}
	// }

	.bg-animate-carousel {
		text-indent: -9999px;
		background-position: center;
		background-repeat: repeat-x;
		background-size: auto 100%;
		animation: carousel 25s linear infinite;
		opacity: 0.8;
		//background-image: url('/images/brands/brands_pack-2-mobile.svg');

		// @screen lg {
		// 	background-image: url('/images/brands/brands_pack.svg');
		// }
	}
	@keyframes carousel {
		0% {
			background-position: 0 center;
		}
		100% {
			background-position: -1620px center;
		}
	}

	.button-special {
		transition: background 0.3s ease;
		text-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
		box-shadow: 0px 167px 67px rgba(0, 0, 0, 0.01), 0px 94px 56px rgba(0, 0, 0, 0.05),
			0px 42px 42px rgba(0, 0, 0, 0.09), 0px 10px 23px rgba(40, 105, 35, 0.29), 0px 0px 0px #5ab953;

		position: relative;
		display: inline-block;
		border-radius: 9999px;
		border-bottom: 2px solid #4f9d4a;
		background-color: #5ab953;
		padding: 0.75em 1.75em;
		&:hover {
			background-color: #4c9446;
		}
	}
	@keyframes move {
		0% {
			top: 0;
			left: 0;
		}
		20% {
			top: 40px;
			left: 60px;
		}
		40% {
			top: 100px;
			left: 100px;
		}
		60% {
			top: 60px;
			left: 40px;
		}
		100% {
			top: 0;
			left: 0;
		}
	}
</style>
